export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/new-selected.29d242a8.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};